import React from "react";
import Testimonials from "../home/Testimonials";

const LeadManagementTestimonials = () => {
  return <Testimonials />;
};

export default LeadManagementTestimonials;
